import styled from 'styled-components';
import StarSolid from '@simplywallst/ui-core/icons/StarSolid';
import { media } from '@simplywallst/ui-core';

export const KeyMetricStatement = styled('div')`
  background-color: ${({ theme }) => theme.color.spaceGray};
  padding: 10px;
  margin-top: ${({ theme }) => `${theme.x1spacePx}px`};
  border-radius: 4px;
  height: min-content;

  mark {
    background-color: transparent;
    color: ${({ theme }) => theme.color.brand01};
  }

  p {
    margin-bottom: 0;
    ${({ theme }) => theme.typography.xSmall};
  }

  ${media.mdUp`
  	margin-top: ${({ theme }) => theme.x2spacePx}px;
  `}
`;

export const StarSolidSVG = styled(StarSolid)`
  > * {
    fill: ${({ theme }) => theme.color.brand01};
  }
`;
